export default __webpack_public_path__ + "static/media/ep_09.97fe6712.png";